// pomodoro.ts - Modern Glassmorphic Circular Pomodoro Timer Logic
document.addEventListener('DOMContentLoaded', () => {
    const timerDisplay = document.getElementById('pomodoro-timer-display');
    const startBtn = document.getElementById('pomodoro-start-btn');
    const pauseBtn = document.getElementById('pomodoro-pause-btn');
    const resetBtn = document.getElementById('pomodoro-reset-btn');
    const add5Btn = document.getElementById('pomodoro-add5-btn');
    const quickStartBtn = document.getElementById('pomodoro-quick-start-btn');
    const statsTbody = document.getElementById('pomodoro-stats-table-tbody');
    const progressCircle = document.getElementById('pomodoro-progress-circle') as unknown as SVGCircleElement | null;
    const modeLabelEl = document.getElementById('pomodoro-mode-label');
    const statusHintEl = document.getElementById('pomodoro-status-hint');
    const completedCountEl = document.getElementById('pomo-completed-count');
    const completedMinutesEl = document.getElementById('pomo-completed-minutes');
    const modeButtons = document.querySelectorAll('.pomo-mode-btn');

    if (!timerDisplay) return;

    const CIRCUMFERENCE = 2 * Math.PI * 130; // ~816.81
    let totalDuration = 25 * 60;
    let timeLeft = totalDuration;
    let timerId: any = null;
    let isRunning = false;
    let currentMode = 'focus';
    let currentModeName = 'Фокус сесія';

    const modeLabels: Record<string, string> = {
        focus: 'Фокус сесія',
        shortBreak: 'Коротка перерва',
        longBreak: 'Тривалий відпочинок',
        deepWork: 'Глибока праця'
    };

    function updateRingProgress() {
        if (!progressCircle) return;
        const progress = Math.max(0, Math.min(1, timeLeft / totalDuration));
        const offset = CIRCUMFERENCE * (1 - progress);
        progressCircle.style.strokeDashoffset = `${offset}`;
    }

    function updateDisplay() {
        if (!timerDisplay) return;
        const m = Math.floor(timeLeft / 60).toString().padStart(2, '0');
        const s = (timeLeft % 60).toString().padStart(2, '0');
        timerDisplay.innerText = `${m}:${s}`;

        updateRingProgress();

        if (modeLabelEl) modeLabelEl.innerText = currentModeName;

        if (isRunning) {
            document.title = `[${m}:${s}] ${currentModeName} | SyncFlow`;
            if (statusHintEl) statusHintEl.innerText = 'Сесія триває...';
        } else if (timeLeft < totalDuration) {
            document.title = `SyncFlow`;
            if (statusHintEl) statusHintEl.innerText = 'Сесію призупинено';
        } else {
            document.title = `SyncFlow`;
            if (statusHintEl) statusHintEl.innerText = 'Натисніть Старт для початку';
        }
    }

    function setMode(mode: string, durationMinutes: number) {
        pauseTimer();
        currentMode = mode;
        currentModeName = modeLabels[mode] || 'Фокус сесія';
        totalDuration = durationMinutes * 60;
        timeLeft = totalDuration;

        modeButtons.forEach(btn => {
            if (btn.getAttribute('data-mode') === mode) {
                btn.classList.add('active');
            } else {
                btn.classList.remove('active');
            }
        });

        updateDisplay();
    }

    modeButtons.forEach(btn => {
        btn.addEventListener('click', () => {
            const mode = btn.getAttribute('data-mode') || 'focus';
            const time = parseInt(btn.getAttribute('data-time') || '25', 10);
            setMode(mode, time);
        });
    });

    async function loadPomodoroStats() {
        (window as any).loadPomodoroStats = loadPomodoroStats;
        if (!statsTbody) return;
        try {
            const res = await fetch('api/pomodoro.php?action=list');
            const data = await res.json();
            if (data.success && Array.isArray(data.data)) {
                renderPomodoroStats(data.data);
                updateDailySummary(data.data);
            }
        } catch (e) {
            console.error('Failed to load pomodoro stats', e);
        }
    }

    function updateDailySummary(sessions: any[]) {
        const todayStr = new Date().toISOString().slice(0, 10);
        const todaySessions = sessions.filter(s => s.completed_at && s.completed_at.startsWith(todayStr));
        const count = todaySessions.length;
        const totalMins = todaySessions.reduce((acc, s) => acc + (parseInt(s.duration_minutes, 10) || 25), 0);

        if (completedCountEl) completedCountEl.innerText = `${count}`;
        if (completedMinutesEl) completedMinutesEl.innerText = `${totalMins} хв`;
    }

    function renderPomodoroStats(sessions: any[]) {
        if (!statsTbody) return;
        statsTbody.innerHTML = '';
        if (sessions.length === 0) {
            statsTbody.innerHTML = `<tr><td colspan="3" style="text-align: center; color: var(--text-dim); padding: 24px;">Завершених сесій Помодоро поки немає</td></tr>`;
            return;
        }

        sessions.forEach(session => {
            const tr = document.createElement('tr');
            const dateStr = session.completed_at ? new Date(session.completed_at).toLocaleString('uk-UA') : '—';
            const durationStr = `${session.duration_minutes || 25} хв`;
            const notesStr = session.notes || 'Сесія фокусу';

            tr.innerHTML = `
                <td class="col-date">${dateStr}</td>
                <td class="col-limit"><span class="badge badge-info" style="padding: 4px 8px; border-radius: 4px; font-weight: 500; font-size: 12px;"><i class="ri-timer-line"></i> ${durationStr}</span></td>
                <td class="col-name">${escapeHtml(notesStr)}</td>
            `;
            statsTbody.appendChild(tr);
        });
    }

    async function saveSession() {
        try {
            const mins = Math.round(totalDuration / 60);
            await fetch('api/pomodoro.php?action=create', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ duration_minutes: mins, notes: `${currentModeName} (${mins} хв)` })
            });
            if ((window as any).showMessage) (window as any).showMessage('Сесію Помодоро успішно завершено та збережено!', 'success');
            loadPomodoroStats();
        } catch (e) {
            console.error('Failed to save pomodoro', e);
        }
    }

    function tick() {
        if (timeLeft > 0) {
            timeLeft--;
            updateDisplay();
        } else {
            clearInterval(timerId);
            isRunning = false;
            if (startBtn) startBtn.style.display = 'inline-flex';
            if (pauseBtn) pauseBtn.style.display = 'none';
            saveSession();
            timeLeft = totalDuration;
            updateDisplay();
        }
    }

    function startTimer() {
        if (!isRunning) {
            isRunning = true;
            timerId = setInterval(tick, 1000);
            if (startBtn) startBtn.style.display = 'none';
            if (pauseBtn) pauseBtn.style.display = 'inline-flex';
            updateDisplay();
        }
    }

    function pauseTimer() {
        if (isRunning) {
            clearInterval(timerId);
            isRunning = false;
            if (startBtn) startBtn.style.display = 'inline-flex';
            if (pauseBtn) pauseBtn.style.display = 'none';
            updateDisplay();
        }
    }

    if (startBtn) startBtn.onclick = startTimer;
    if (pauseBtn) pauseBtn.onclick = pauseTimer;

    if (resetBtn) {
        resetBtn.onclick = () => {
            pauseTimer();
            timeLeft = totalDuration;
            updateDisplay();
        };
    }

    if (add5Btn) {
        add5Btn.onclick = () => {
            timeLeft += 5 * 60;
            totalDuration += 5 * 60;
            updateDisplay();
        };
    }

    if (quickStartBtn) {
        quickStartBtn.onclick = () => {
            const timerSubBtn = document.querySelector('.sub-tab-button[data-sub-tab="pomodoro-timer"]') as HTMLElement | null;
            if (timerSubBtn) timerSubBtn.click();
            startTimer();
        };
    }

    function escapeHtml(str: string) {
        return str
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    const pomodoroTabBtn = document.querySelector('button[data-tab="pomodoro"]');
    if (pomodoroTabBtn) {
        pomodoroTabBtn.addEventListener('click', () => {
            loadPomodoroStats();
        });
    }

    const statsSubTabBtn = document.querySelector('.sub-tab-button[data-sub-tab="pomodoro-stats"]');
    if (statsSubTabBtn) {
        statsSubTabBtn.addEventListener('click', () => {
            loadPomodoroStats();
        });
    }

    updateDisplay();
    loadPomodoroStats();
});
